<template>
	<div class="input-group" :class="[setSize]">
		<span v-if="!Array.isArray(addon)&&!right" class="input-group-addon" :class="[setBtn]">
			{{addon}}
			<slot name="left"></slot>
		</span>
		<span v-else-if="!right" class="input-group-addon" :class="[setBtn]">
			{{addon[0]}}
		</span>
		<slot name="input"></slot>
		<span v-if="Array.isArray(addon)" class="input-group-addon">
			{{addon[1]}}
		</span>
		<span v-if="!Array.isArray(addon)&&right" class="input-group-addon" :class="[setBtn]">
			{{addon}}
			<slot name="right"></slot>
		</span>
	</div>
</template>

<script>
	import bsfBtn from './btn'
	import bsfInput from './input'
	export default {
		name: 'bsf-input-group',
		components: {
			bsfBtn,
			bsfInput
		},
		props: {
			size: {
				type: String,
			},
			addon: {
				type: [String, Array]
			},
			right: {
				type: Boolean
			},
			btn: {
				type: Boolean
			}
		},
		data: function() {
			return {}
		},
		mounted: function() {
			this.$nextTick(function() {})
		},
		computed: {
			setSize() {
				return this.size ? 'input-group-' + this.size : '';
			},
			setBtn(){
				if(this.btn){
					return 'input-group-btn'
				}
			}
		},
		watch: {

		}

	}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
	@import (reference) "../../../assets/lib/css.less";
	.form-control {
		input& {
			.unbdr;
		}
	}
</style>


// WEBPACK FOOTER //
// inputgroup.vue?2c4507fc